import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getAreaStatistics} from '@apis'
import EnergyStatisticsItem from './energy-statistics-item'

const EnergyBlock = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo
    const [totalCount, setTotalCount] = useState(null)
    const [areaList, setAreaList] = useState([])

    async function queryAreaStatistic() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
        dimension: 3,
      }
      const res = await getAreaStatistics(params)
      if (res && res.data) {
        const total = res.data.reduce((all, currentValue) => {
          return currentValue.energy + all
        }, 0)
        setTotalCount(total)
        setAreaList(res.data)
      }
    }

    useEffect(() => {
      queryAreaStatistic()
    }, [])

    return (
      <div className="energy-top" style={{position: 'relative'}}>
        <EnergyStatisticsItem
          title="总能耗"
          chartData={totalCount || totalCount === 0 ? [{
            value: totalCount
          }] : null}
        >
        </EnergyStatisticsItem>
        <div className="verticle-line" />
        {
          areaList.slice(0, 5).map(item => (
            <EnergyStatisticsItem
              title={item.areaName}
              chartData={[{
                value: item.energy
              }]}
            >
            </EnergyStatisticsItem>
          ))
        }
      </div>
    )
  })
)

export default EnergyBlock
